// extracted by mini-css-extract-plugin
export default {"introHead":"Intro_introHead__JZ9Fg","introBody":"Intro_introBody__iMCxd","introWrapperImage":"Intro_introWrapperImage__ERWGo","introImg":"Intro_introImg__AoFdB"};